/**
 * @description 自動 Refresh SSO Token
 *
 * @property {Function} getRefreshToken - Refresh token API
 * 範例:
 * const refreshTokenAPI = () => {
 *    const data = `grant_type=refresh_token&refresh_token=${refreshToken}&client_id=${clientId}`
 *    return axios.post('/_sso/token', data)
 * }
 *
 * @property {Function} getTokenCallback - 將 token & refresh token 回傳
 * 範例:
 * const getTokenCallback = (data: { token: string; refreshToken: string }) => {}
 *
 */

import { LitElement, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { type RefreshTokenResponse } from '../types/api';

@customElement('ls-refresh-sso')
export class LsRefreshSso extends LitElement {
    @property({ type: Function }) getRefreshToken: () => Promise<RefreshTokenResponse> = () =>
        Promise.resolve({} as RefreshTokenResponse);
    @property({ type: Function }) getTokenCallback: (data: { token: string; refreshToken: string }) => void = () => {};

    @state() timeout: Array<NodeJS.Timeout> = [];

    private async _getRefreshToken() {
        try {
            if (document.visibilityState === 'visible') {
                const res = await this.getRefreshToken();
                this.getTokenCallback({
                    token: `${res.data.token_type} ${res.data.access_token}`,
                    refreshToken: res.data.refresh_token,
                });
                localStorage.setItem('get_token_timestamp', Date.now().toString());
            }
            this._setTimer();
            this.timeout.shift();
        } catch (e) {
            console.log(e);
        }
    }

    private _getRefreshTime() {
        const getTokenTimestamp = localStorage.getItem('get_token_timestamp');
        if (!getTokenTimestamp) return 0;

        const refreshTime = +getTokenTimestamp + 100 * 60 * 1000; // 100 minutes
        const now = Date.now();

        return refreshTime - now;
    }

    private _setTimer() {
        const timer = this._getRefreshTime();
        this.timeout.push(setTimeout(() => this._getRefreshToken(), timer));
    }

    private _checkVisible() {
        if (document.visibilityState === 'visible') {
            for (let i = 0; i < this.timeout.length; i++) {
                clearTimeout(this.timeout[i]);
            }
            this.timeout = [];
            this._setTimer();
        }
    }

    connectedCallback(): void {
        super.connectedCallback();
        this._setTimer();

        document.addEventListener('visibilitychange', () => this._checkVisible());
    }

    render() {
        return html`<div style="display: none;"></div>`;
    }
}
